const Config = {
	isDebug: false,
	isHashRoute: true,
	LSNames: {
		recipes: "recipes"
	},
};

module.exports = Config;